export const useSanitizeTextForWordExport = (text: string) => {
  return text.replace(/[\uD800-\uDFFF]/g, function (char) {
    return "";
  });
};
